"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestType = void 0;
var RequestType;
(function (RequestType) {
    RequestType["ADD_FUEL"] = "Add Fuel";
    RequestType["ADD_PROPERTY"] = "Add Property";
    RequestType["BUSINESS_MASTER_DATA"] = "Business Master Data";
    RequestType["FORCE_MOVE_OUT"] = "Force Move-Out";
    RequestType["FRMP_OR_FRO_MOVE_IN"] = "FRMP/FRO Move-In, Backdated Move-In";
    RequestType["MOVE_IN"] = "Move-In";
    RequestType["MOVE_OUT_AND_MOVE_IN"] = "Move-Out & Move-In";
    RequestType["NEW_CONNECTION"] = "New Connection";
    RequestType["ONE_MINUTE_MOVE"] = "One Minute Move";
    RequestType["PRODUCT_REPLACEMENT"] = "Product Replacement";
    RequestType["QUOTE_OR_CONTACT_CREATION"] = "Quote or Contract Creation";
    RequestType["REQUEST_FOR_MOVE_IN"] = "Request for Move-In";
    RequestType["REQUEST_FOR_MOVE_OUT"] = "Request for Move-Out";
    RequestType["SWITCH"] = "Switch";
    RequestType["TECHNICAL_MASTER_DATA"] = "Technical Master Data";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
//# sourceMappingURL=request-type.enum.js.map